import React, { useEffect } from 'react'
import styled from 'styled-components/macro'

import { TransparentButton } from '../Buttons'
import { CloseMiniIcon } from '../../../Assets'
import {
  transforms,
  DrawerWrapper,
  DrawerOverlay,
  DrawerContent,
} from './defaultComponents'
import { getCustomComponents } from '../../PatientUpload/common/Themes'

interface DrawerProps {
  open: boolean
  size?: string | number
  position?: keyof typeof transforms
  onClose: () => void
  customerTheme?: string
  styles?: string
  showCloseButton?: boolean
  speed?: number
  padding?: string
}

const defaultComponents = {
  DrawerWrapper,
  DrawerOverlay,
  DrawerContent,
}

const Drawer: React.FunctionComponent<DrawerProps> = ({
  open = false,
  size = '600px',
  position = 'right',
  onClose,
  customerTheme = '',
  children,
  styles,
  showCloseButton = false,
  speed = 0.6,
  padding = '48px 40px',
}) => {
  const { DrawerWrapper, DrawerOverlay, DrawerContent } = {
    ...defaultComponents,
    ...getCustomComponents(customerTheme),
  }

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [open])

  return (
    <DrawerWrapper open={open} size="auto" position={position}>
      <DrawerOverlay open={open} onClick={onClose} />
      <DrawerContent
        styles={styles}
        open={open}
        size={size}
        position={position}
        speed={speed}
        padding={padding}
      >
        {showCloseButton && (
          <StyledButton
            onClick={() => onClose()}
            aria-label="Close the drawer"
            name="closeDrawer"
          >
            <img src={CloseMiniIcon} alt="Close drawer icon" />
          </StyledButton>
        )}
        {open && children}
      </DrawerContent>
    </DrawerWrapper>
  )
}

const StyledButton = styled(TransparentButton)`
  position: absolute;
  width: 1rem;
  right: 48px;
  top: 60px;
  background-color: transparent;
  z-index: 2;
`

export default Drawer
